import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import Box from '@mui/material/Box';
import {
  ModeValues,
  useSegmentHeaderElements,
} from '../../drawer/components/SegmentListItem/useSegmentHeaderElements.tsx';
import type { LookalikeDefinitionSegments } from '../../drawer/hooks/lookalike/lookalikeSegmentsReducer.ts';
import { boxIconContainerStyles, containerStyles } from '../../utils/segmentListItemStyles.ts';
import { SeedSegmentItem } from './SeedSegmentItem.tsx';
import { SimilaritySegmentItem } from './SimilaritySegmentItem.tsx';

export type LookalikeListItemProps = {
  definition: LookalikeDefinitionSegments;
  onDelete: () => void;
  onEdit: () => void;
  isEditDisabled?: boolean;
};

export const LookalikeListItem = ({
  definition: { similaritySegment, seedSegment },
  onDelete,
  onEdit,
  isEditDisabled = false,
}: LookalikeListItemProps) => {
  const defaultHeaderConfig = useSegmentHeaderElements({
    mode: ModeValues.lookalikeEditable,
    onEdit: onEdit,
    onRemove: onDelete,
  });

  const headerConfig = isEditDisabled
    ? {
        leftIcon: <CheckCircleOutlined color="success" fontSize="small" />,
        rightIcon: '',
      }
    : defaultHeaderConfig;

  if (!similaritySegment) {
    return null;
  }

  return (
    <Box sx={containerStyles} data-test="lookalike-item">
      <SimilaritySegmentItem
        segment={similaritySegment}
        isSelectedItem
        headerConfig={{ leftIcon: headerConfig.leftIcon, rightIcon: undefined }}
      />
      {seedSegment && <SeedSegmentItem segment={seedSegment} />}

      <Box sx={boxIconContainerStyles} className="icon-container">
        {headerConfig.rightIcon}
      </Box>
    </Box>
  );
};
